// AWS Amplify Configuration for Cognito

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_R5NQn4faU',
      userPoolClientId: '4cmuljjhauq9aakgvln2d5j5uf',
      loginWith: {
        email: true,
      },
    }
  }
};

